import StatusPill from "./StatusPill";
import "../reportDashboard.scss";

// Vertical timeline — Case / Observation / Reprimand logs.
// items: [{ id, date, title, status, subtitle, subtitles, trailingPill, tone }]
// `subtitles` (string[]) renders one .rdTimeline__subtitle line per entry,
// taking priority over the single `subtitle` string when both are given —
// e.g. a Safety Meeting item's "Instructor: …" + "N attendee(s) logged" lines.
// `trailingPill` renders as a muted rdPill at the end of the first subtitle
// line (e.g. "N/M instructors completed").
const Timeline = ({ items, emptyLabel = "No data recorded", onItemClick, maxHeight = 320 }) => {
  if (!items || items.length === 0) {
    return <div className="rdEmpty">{emptyLabel}</div>;
  }
  return (
    <div className="rdTimeline" style={{ "--rd-max-height": `${maxHeight}px` }}>
      {items.map((item) => {
        const subtitleLines =
          item.subtitles && item.subtitles.length > 0
            ? item.subtitles
            : item.subtitle
              ? [item.subtitle]
              : [];
        return (
          <div
            key={item.id}
            onClick={onItemClick ? () => onItemClick(item) : undefined}
            className={
              onItemClick
                ? "rdTimeline__item rdTimeline__item--clickable"
                : "rdTimeline__item"
            }
          >
            <div className={`rdTimeline__dot is-${item.tone || "accent"}`} />
            <div className="rdTimeline__body">
              <div className="rdTimeline__meta">
                <span>{item.date || "—"}</span>
                {item.status && <StatusPill status={item.status} />}
                {item.badge && <span>{item.badge}</span>}
              </div>
              <div className="rdTimeline__title">{item.title || "—"}</div>
              {subtitleLines.map((line, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className="rdTimeline__subtitle" key={i}>
                  {line}
                  {i === 0 && item.trailingPill && (
                    <span className="rdPill rdPill--soft is-muted rdTimeline__trailingPill">
                      {item.trailingPill}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Timeline;
